import { SettingsState } from '../../../typedefs/store';
import * as React from 'react';
import styled, { StyledFunction } from 'styled-components';
import * as ChatBubbleIcon from 'react-icons/lib/io/chatbubble';

interface Props {
    numUnread: number;
    onClick: () => void;
    settings: SettingsState;
}
interface State {}

export default class Minimized extends React.Component<Props, State> {
    render() {
        return (
            <Positioner className="conversations-cta-container conversations-cta-mobile">
                <Tab className="conversations-cta" href="#" settings={this.props.settings} onClick={this.props.onClick}>
                    <IconWrapper>
                        {this.props.numUnread > 0 && (
                            <Unread settings={this.props.settings}>{this.props.numUnread}</Unread>
                        )}
                        <ChatBubbleIcon size={24} />
                    </IconWrapper>
                    <div>Chat</div>
                </Tab>
            </Positioner>
        );
    }
}

const Positioner = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    align-items: flex-center;
`;

const IconWrapper = styled.div`
    position: relative;
    flex-shrink: 0;
    margin-right: 10px;
`;

const div: StyledFunction<{ settings: any } & React.HTMLProps<HTMLInputElement>> = styled.div;
const Unread = div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 500;
    color: ${props => props.settings.ctaBackgroundColor};
`;

const a: StyledFunction<{ settings: any } & React.HTMLProps<HTMLInputElement>> = styled.a;
const Tab = a`
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5px;
    background-color: ${props => props.settings.ctaBackgroundColor};
    color: ${props => props.settings.ctaForegroundColor};
    &:hover {
        color: ${props => props.settings.ctaForegroundColor};
    }
    font-size: 16px;
    text-transform: uppercase;
    text-decoration: none;
    border-radius: 3px 3px 0 0;
    border-top: 3px solid white;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Mobile/Minimized.tsx